




import {Component, Prop, Vue} from "vue-property-decorator";
import {IdMapper} from "@/interfaces/state/base";
import {PickingListTranshipmentStatus} from "@/enums/status";

@Component({
    name: "PLTranshipmentStatusLabel"
})
export default class extends Vue {
    @Prop({ required: true })
    readonly status!: number;

    PickingListTranshipmentStatus = PickingListTranshipmentStatus;
    colorMap: IdMapper<string> = {
        [PickingListTranshipmentStatus.Transhipmenting]: 'warning',
        [PickingListTranshipmentStatus.ConfirmedMissing]: 'processing',
        [PickingListTranshipmentStatus.ConfirmedTranshipment]: 'success'
    }
}
